import { formatDate } from "common/service/CommonService";
import Commonbadge from "Components/Common/Commonbadge";
import CommonTableIndexWise from "Components/Common/CommonTableIndexWise";
import TruncatedText from "Components/Common/TruncatedText";
import { useState } from "react";
import { Button, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap";
import styles from "../css/volunteerstudydashboard.module.scss";
import { getFileIcon } from "modules/Volunteer/MasterVolunteer/helper/volunteer.constant";
import profileImage from "../../../../assets/images/volunteer.png";

/* ================= KEY VALUE MAP ================= */
export const keyLabelMap: Record<string, string> = {
  // Registration
  registrationsummary: "Registration Summary",
  volunteerregisteredby: "Registered By",
  volunteerregistereddate: "Registered Date",
  volunteerregisteredtime: "Registered Time",
  volunteerregisteredstatus: "Registration Status",
  volunteerinformation: "Volunteer Information",
  profileimage: "Profile Image",
  signature: "Signature",
  volunteercode: "Volunteer Code",
  fullname: "Full Name",
  initials: "Initials",
  gender: "Gender",
  dob: "Date of Birth",
  age: "Age",
  currentstatus: "Current Status",
  mobilenumber: "Mobile Number",
  emailaddress: "Email Address",
  address: "Address",
  city: "City",
  state: "State",
  pincode: "Pincode",
  emergencycontactname: "Emergency Contact Name",
  emergencycontactnumber: "Emergency Contact Number",
  volunteermedicalinformation: "Medical Information",
  height: "Height",
  weight: "Weight",
  bmi: "BMI",
  bloodgroup: "Blood Group",
  smoking: "Smoking",
  allergies: "Allergies",
  medicalhistory: "Medical History",
  currentmedication: "Current Medication",
  pulserate: "Pulse Rate",
  temperature: "Temperature",
  volunteerdemographics: "Demographics",
  maritalstatus: "Marital Status",
  ethnicity: "Ethnicity",
  religion: "Religion",
  occupation: "Occupation",
  educationlevel: "Education Level",
  primarylanguage: "Primary Language",
  foodhabit: "Food Habit",
  populationgroup: "Population Group",
  literatestatus: "Literate Status",
  race: "Race",
  volunteerattachments: "Volunteer Attachments",

  // Assigned
  assignedstudysummary: "Assigned Study Summary",
  assignedstudycode: "Assigned Study Code",
  assignedstudytitle: "Assigned Study Title",
  studydesign: "Study Design",
  numberofperiods: "Number of Periods",
  washoutdays: "Washout Days",
  studyassignedby: "Assigned By",
  studyassigneddate: "Assigned Date",
  studyassignedtime: "Assigned Time",
  studyassignmentstatus: "Assignment Status",

  // Screening
  screeningsummary: "Screening Summary",
  screeningname: "Screening Name",
  screeningvaliditydays: "Screening Validity Days",
  screeningdate: "Screening Date",
  screeningtime: "Screening Time",
  expirydate: "Expiry Date",
  screeningdecision: "Screening Decision",
  decisionby: "Decision By",
  decisiondate: "Decision Date",
  decisiontime: "Decision Time",
  icf: "ICF Details",
  icfversion: "ICF Version",
  language: "Language",
  type: "Type",
  signeddate: "Signed Date",
  remarks: "Remarks",
  checklist: "Checklist",
  question: "Question",
  required: "Required",
  answer: "Answer",
  alcoholtests: "Alcohol Tests",
  bloodalcoholconcentration: "Blood Alcohol Concentration",
  alcoholunit: "Alcohol Unit",
  alcoholresult: "Alcohol Result",
  indicatorlightcolor: "Indicator Light Color",
  reportedby: "Reported By",
  reporteddate: "Reported Date",
  reportedtime: "Reported Time",
  labtests: "Lab Tests",
  reportname: "Report Name",
  filetype: "File Type",
  filesize: "File Size",
  verificationstatus: "Verification Status",
  verifiedby: "Verified By",
  verifieddate: "Verified Date",
  verifiedtime: "Verified Time",
  crf: "CRF Details",
  crfname: "CRF Name",
  crfdetails: "CRF Details",

  // Transfer
  transfersummary: "Transfer Summary",
  fromstudycode:"From Study Code",
  tostudycode:"To Study code",
  fromstudytitle :"From Study Title",
  tostudytitle:"To Study Title",
  transfertype:"Transfer Type",
  transferreason:"Transfer Reason",
  transferdate :"Transfer Date ",
  transfertime:"Transfer Time",
  screeningrequired :"Screening Required",
  transferredby:"Transfered By",
  // Enrollment
  enrollmentsummary: "Enrollment Summary",
  subjectnumber: "Subject Number",
  subjectbarcode: "Subject Barcode",
  subjectstatus: "Subject Status",
  enrollmentdate: "Enrollment Date",
  enrollmenttime: "Enrollment Time",
  enrolledby: "Enrolled By",
  subjectlabelprinting: "Subject Label Printing",
  printhistory: "Print History",
  printid: "Print ID",
  printcount: "Print Count",
  barcode: "Barcode",
  printedby: "Printed By",
  printeddate: "Printed Date",
  printedtime: "Printed Time",
  reasonforreprint: "Reason for Reprint",
  subjectidcardprinting: "Subject ID Card Printing",

  // Periods
  periodsummary: "Period Summary",
  studycode: "Study Code",
  studytitle: "Study Title",
  totalperiods: "Total Periods",
  completedperiods: "Completed Periods",
  remainingperiods: "Remaining Periods",
  perioddetails: "Period Details",
  periodnumber: "Period Number",
  checkincheckout: "Check In / Check Out",
  dosing: "Dosing Details",
  predosescheduledate: "Predose Schedule Date",
  predosetime: "Predose Time",
  predosesamplevolume: "Predose Sample Volume",
  dosescheduledate: "Dose Schedule Date",
  dosetime: "Dose Time",
  actualdosetime: "Actual Dose Time",
  dosevolume: "Dose Volume",
  totaldosingstations: "Total Dosing Stations",
  timepoints: "Timepoints",
  timepoint: "Timepoint",
  collection: "Collection Details",
  collectionstatus: "Collection Status",
  collectiondate: "Collection Date",
  collectiontime: "Collection Time",
  vaccutainerbarcode: "Vaccutainer Barcode",
  dosingstation: "Dosing Station",
  sampleseparation: "Sample Separation",
  aliquotnumber: "Aliquot Number",
  aliquotbarcode: "Aliquot Barcode",

  // Dynamic Periods Field Mappings
  actualcheckin: "Actual Check In",
  actualcheckindate: "Actual Check In Date",
  actualcheckintime: "Actual Check In Time",
  checkinstatus: "Check In Status",
  actualcheckout: "Actual Check Out",
  actualcheckoutdate: "Actual Check Out Date",
  actualcheckouttime: "Actual Check Out Time",
  checkoutstatus: "Check Out Status",
  actualdosedate: "Actual Dose Date",
  actualdosingdate: "Actual Dosing Date",
  actualdosingtime: "Actual Dosing Time",
  dosingstatus: "Dosing Status",
  dosedby: "Dosed By",
  performedby: "Performed By",
  performeddate: "Performed Date",
  samplecollection: "Sample Collection",
  vacutainerbarcodescan: "Vaccutainer Barcode Scan",
  samplecollectionid: "Sample Collection ID",
  timepoint_number: "Timepoint Number",
  timepoint_sort: "Timepoint Sort",
  samplecollectiontime: "Sample Collection Time",
  samplecollectionstatus: "Sample Collection Status",
  dosingscheduledate: "Dosing Schedule Date",
  isverified: "Is Verified?",
  iscorrection: "Is Correction?",
  iscorrectionverified: "Is Correction Verified?",
  subjectvacutainerbarcodescan: "Subject Vacutainer Barcode Scan",

  // Ambulatory Visit
  visitsdetails: "Visits Details",
  visitinformation: "Visit Information",
  visitnumber: "Visit Number",
  visitname: "Visit Name",
  visitdescription: "Visit Description",
  visitwindow: "Visit Window",
  scheduleddate: "Scheduled Date",
  visitstatus: "Visit Status",
  checkindate: "Check-in Date",
  checkintime: "Check-in Time",
  checkoutdate: "Check-out Date",
  checkouttime: "Check-out Time",
  activitiesresult: "Activities Result",
  activityname: "Activity Name",
  activitydescription: "Activity Description",
  estimatedduration: "Estimated Duration",
  activityresult: "Activity Result",
  attachments: "Attachments",
  decision: "Decision Details",
  decisionstatus: "Decision Status",
  decisionremarks: "Decision Remarks",

  // Adverse Event
  adverseevents: "Adverse Events",
  adverseeventid: "Adverse Event ID",
  adverseeventnumber: "Adverse Event Number",
  eventterm: "Event Term",
  onsetdate: "Onset Date",
  resolutiondate: "Resolution Date",
  eventstatus: "Event Status",
  eventstatustext: "Event Status",
  bordercol: "Border Color",
  severitygrade: "Severity Grade",
  severitygradetext: "Severity Grade",
  causality: "Causality",
  causalitytext: "Causality",
  actiontaken: "Action Taken",
  actiontakentext: "Action Taken",
  isadverse: "Is Adverse?",

  // Drop Out
  dropouthistory: "Drop Out History",
  dropouttype :"Dropout Type",
  studystage : "Study Stage",
  dropoutreason : "Dropout Reason",
  dropoutdate :"Dropout Date",
  effectivedate:"Effective Date",
  aereferenceno :"Adverse Event Number",
  dropoutby :"Dropout By",

  // Block
  blockhistory: "Block History",

  // Study Completed
  studycompletionsummary: "Study Completion Summary",
  studystatus: "Study Status",
  studycompletedby: "Completed By",
  studycompleteddate: "Completed Date",
  studycompletedtime: "Completed Time"
};

/* ================= COLLAPSIBLE CARD ================= */
export const CollapsibleCard: React.FC<{
  title: React.ReactNode;
  badge?: React.ReactNode;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}> = ({ title, badge, defaultExpanded = false, children }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Card className="border shadow-none mb-3" style={{ borderRadius: "8px", overflow: "hidden", transition: "all 0.3s ease" }}>
      <div
        className="py-2 px-3 d-flex align-items-center justify-content-between cursor-pointer"
        style={{
          backgroundColor: "#f8fafc",
          borderBottom: expanded ? "1px solid #e2e8f0" : "none",
          transition: "all 0.3s ease",
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <h6 className="text-primary mb-0 d-flex align-items-center gap-2" style={{ fontWeight: 600, minWidth: 0, flex: 1 }}>
          <i className="ri-folder-open-line" style={{ flexShrink: 0, transition: "transform 0.3s", transform: expanded ? "scale(1.1)" : "scale(1)" }} />
          {typeof title === "string" ? (
            <TruncatedText text={title} />
          ) : (
            title
          )}
        </h6>
        <div className="d-flex align-items-center gap-3" onClick={(e) => e.stopPropagation()}>
          {badge}
          <i
            className={expanded ? "ri-arrow-up-s-line fs-5 text-secondary" : "ri-arrow-down-s-line fs-5 text-secondary"}
            style={{
              transition: "transform 0.3s ease",
              transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
              cursor: "pointer",
            }}
            onClick={() => setExpanded(!expanded)}
          />
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateRows: expanded ? "1fr" : "0fr",
          transition: "grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <div style={{ overflow: "hidden" }}>
          <CardBody className="p-3" style={{ backgroundColor: "#fff" }}>
            {children}
          </CardBody>
        </div>
      </div>
    </Card>
  );
};


/* ================= UTILS ================= */
export const findRecordId = (record: any): string | null => {
  if (!record || typeof record !== "object") return null;

  // Explicit top-level or nested properties first
  const explicit = 
    record.adverseeventid || record.adverseEventId ||
    record.blockid || record.blockId || record.volunteerblockid ||
    record.volunteerblockhistoryid ||
    record.dropoutid || record.dropOutId || record.volunteerdropoutid ||
    record.volunteerdropouthistoryid ||
    record.transferid || record.transferId || record.volunteertransferid ||
    record.volunteertransferhistoryid ||
    record.visitid || record.visitId || record.ambulatoryvisitid ||
    record.visitinformation?.visitid || record["visitinformation"]?.["visitid"] ||
    record.visitinformation?.visitId || record["Visit Information"]?.["Visit ID"];
    
  if (explicit) return String(explicit);

  // Fallback: look for any key ending with "id" in lowercase recursively
  let foundId: string | null = null;
  const search = (obj: any) => {
    if (!obj || typeof obj !== "object" || foundId) return;
    
    // Check explicit keys on this sub-level
    const explicitSub = 
      obj.adverseeventid || obj.adverseEventId ||
      obj.blockid || obj.blockId || obj.volunteerblockid ||
      obj.volunteerblockhistoryid ||
      obj.dropoutid || obj.dropOutId || obj.volunteerdropoutid ||
      obj.volunteerdropouthistoryid ||
      obj.transferid || obj.transferId || obj.volunteertransferid ||
      obj.volunteertransferhistoryid ||
      obj.visitid || obj.visitId || obj.ambulatoryvisitid;
    if (explicitSub) {
      foundId = String(explicitSub);
      return;
    }

    // Check all keys ending with "id"
    for (const [k, val] of Object.entries(obj)) {
      const lowerK = k.toLowerCase();
      if (lowerK.endsWith("id") && lowerK !== "subjectid" && (typeof val === "string" || typeof val === "number")) {
        foundId = String(val);
        return;
      }
    }
    
    // Recursively search sub-objects
    for (const val of Object.values(obj)) {
      if (val && typeof val === "object") {
        search(val);
      }
    }
  };

  search(record);
  return foundId;
};

// Helper to safely join fileBaseUrl and file path
  export const resolveFileUrl = (path: string | null | undefined): string => {
    if (!path || path === "null" || path.trim() === "") return "";
    const baseUrl = localStorage.getItem("filebaseUrl") || "";
    if (!baseUrl) return path;
    const cleanBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${cleanBase}${cleanPath}`;
  };

    // Key formatting helper
  export const formatLabel = (key: string): string => {
    if (!key) return "";
    const cleanKey = key.trim();
    const mapped = keyLabelMap[cleanKey] || keyLabelMap[cleanKey.toLowerCase()];
    if (mapped) return mapped;

    if (key.includes(" ") || key.includes("-")) return key;
    // Convert camelCase or PascalCase to Title Case
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  };

 export  const getDisplayValue = (val: any): string => {
    if (val === null || val === undefined) return "-";
    const str = String(val).trim();
    if (
      str === "" ||
      str.toLowerCase() === "null" ||
      str.toLowerCase() === "undefined" ||
      str === "—" ||
      str === "--"
    ) {
      return "-";
    }
    return str;
  };

export  const renderCRFDetails = (crfDetails: any) => {
      if (!crfDetails || typeof crfDetails !== "object") return null;
  
      const pages = crfDetails.pages || [];
      const answers = crfDetails.answers || {};
  
      const questions: { name: string; title: string; type: string }[] = [];
      pages.forEach((page: any) => {
        if (Array.isArray(page.elements)) {
          page.elements.forEach((el: any) => {
            if (el.name) {
              questions.push({
                name: el.name,
                title: el.title || el.name,
                type: el.type || "text",
              });
            }
          });
        }
      });
  
      if (questions.length === 0 && Object.keys(answers).length === 0) {
        return <div className="text-muted small">No CRF details available.</div>;
      }
  
      if (questions.length === 0) {
        // Fallback: render answers object as flat key-value list
        return (
          <div
            className="d-flex flex-column gap-2 p-3 rounded"
            style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}
          >
            {Object.entries(answers).map(([key, val]) => (
              <div
                key={key}
                className="pb-2 border-bottom d-flex flex-column gap-1"
                style={{ borderBottomStyle: "dashed", borderColor: "#e2e8f0" }}
              >
                <span className="text-secondary fw-semibold" style={{ fontSize: "11px" }}>
                  {formatLabel(key)}
                </span>
                <span className="text-dark fw-bold" style={{ fontSize: "13px" }}>
                  {getDisplayValue(val)}
                </span>
              </div>
            ))}
          </div>
        );
      }
  
      return (
        <div
          className="d-flex flex-column gap-2 p-3 rounded"
          style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0" }}
        >
          {questions.map((q, idx) => {
            const ans = answers[q.name];
            const displayAns = ans !== null && ans !== undefined ? String(ans) : "—";
            return (
              <div
                key={q.name}
                className="pb-2 border-bottom d-flex flex-column gap-1"
                style={{ borderBottomStyle: "dashed", borderColor: "#e2e8f0" }}
              >
                <span className="text-secondary fw-semibold" style={{ fontSize: "11px" }}>
                  Q{idx + 1}: {q.title}
                </span>
                <span className="text-dark fw-bold ps-2 d-flex align-items-center gap-2" style={{ fontSize: "13px" }}>
                  <i className="ri-checkbox-circle-fill text-success" />
                  {displayAns}
                </span>
              </div>
            );
          })}
        </div>
      );
    };

    export  const handleNavigateToView = (moduleKey: string, record: any , navigate: any) => {
    const id = findRecordId(record);
    if (!id) return;

    const lowerKey = moduleKey.toLowerCase();
    if (lowerKey.includes("adverse")) {
      navigate(`/adverse-event/view/${id}`);
    } else if (lowerKey.includes("block")) {
      navigate(`/block-volunteer/view/${id}`);
    } else if (lowerKey.includes("dropout") || lowerKey.includes("drop out")) {
      navigate(`/dropout-volunteer/view/${id}`);
    } else if (lowerKey.includes("transfer")) {
      navigate(`/transfer-volunteer/view/${id}`);
    } else if (lowerKey.includes("ambulatory") || lowerKey.includes("visit")) {
      navigate(`/ambulatory-visit/view/${id}`);
    }
  };

  
   export const hasViewDetailsLink = (moduleKey: string, record: any): boolean => {
      if (!moduleKey) return false;
      const lowerKey = moduleKey.toLowerCase();
      
      // Only allow specific modules that have view details routes
      const isAllowedModule =
        lowerKey.includes("adverse") ||
        lowerKey.includes("block") ||
        lowerKey.includes("dropout") ||
        lowerKey.includes("drop out") ||
        lowerKey.includes("transfer") ||
        lowerKey.includes("visit") ||
        lowerKey.includes("ambulatory");
  
      if (!isAllowedModule) {
        return false;
      }
      return !!findRecordId(record);
    };

    
 export  const isStatusField = (key: string): boolean => {
        if (!key) return false;
        const k = key.toLowerCase();
        if (
          k.includes("remark") ||
          k.includes("by") ||
          k.includes("date") ||
          k.includes("time") ||
          k.includes("desc") ||
          k.includes("reason") ||
          k.includes("comment")
        ) {
          return false;
        }
        return k.endsWith("status") || k === "status" || k === "decision" || k === "result";
      };


  // Completely dynamic rendering function for data sections
export  const renderSectionData = (
  sectionKey: string, 
  sectionVal: any ,
  navigate:any ,
  setSelectedCRF:any ,
  onViewAttachment:any,
  activeSubTabs:any,
  setActiveSubTabs:any,
): React.ReactNode => {
    if (sectionVal === null || sectionVal === undefined) return <span className="text-muted">—</span>;

    // Case 1: Array of data
    if (Array.isArray(sectionVal)) {
      if (sectionVal.length === 0) {
        return <div className="text-muted small p-2 bg-light rounded">No records available.</div>;
      }

      if (sectionKey.toLowerCase() === "samplecollection" || sectionKey.toLowerCase() === "sample_collection") {
        const columns: any[] = [
          {
            key: "timepoint",
            label: "Timepoint",
            cell: (row: any) => getDisplayValue(row.timepoint_number || row.timepointnumber || row.timepoint)
          },
          {
            key: "dosingstation",
            label: "Dosing Station",
            cell: (row: any) => getDisplayValue(row.dosingstation)
          },
           {
            key: "dosingscheduledate",
            label: "Dosing Schedule Date",
            cell: (row: any) => getDisplayValue(row.dosingscheduledate)
          },
          {
            key: "actualdosetime",
            label: "Actual Dose Time",
            cell: (row: any) => getDisplayValue(row.actualdosetime)
          },
          {
            key: "samplecollectiontime",
            label: "Sample Collection Time",
            cell: (row: any) => getDisplayValue(row.samplecollectiontime)
          },
          {
            key: "subjectbarcode",
            label: "Subject Barcode",
            cell: (row: any) => {
              const scan = row.subjectvacutainerbarcodescan || row.vacutainerbarcodescan || {};
              const scanObj = Array.isArray(scan) ? (scan[0] || {}) : scan;
              return getDisplayValue(scanObj.subjectbarcode || scanObj.subjectBarcode);
            }
          },
          {
            key: "vaccutainerbarcode",
            label: "Vacutainer Barcode",
            cell: (row: any) => {
              const scan = row.subjectvacutainerbarcodescan || row.vacutainerbarcodescan || {};
              const scanObj = Array.isArray(scan) ? (scan[0] || {}) : scan;
              return getDisplayValue(scanObj.vaccutainerbarcode || scanObj.vaccutainerbarcode);
            }
          },
          {
            key: "scanby",
            label: "Scan By",
            cell: (row: any) => {
              const scan = row.subjectvacutainerbarcodescan || row.vacutainerbarcodescan || {};
              const scanObj = Array.isArray(scan) ? (scan[0] || {}) : scan;
              return getDisplayValue(scanObj.scanby || scanObj.scanBy);
            }
          },
          {
            key: "scandatetime",
            label: "Scan Date & Time",
            cell: (row: any) => {
              const scan = row.subjectvacutainerbarcodescan || row.vacutainerbarcodescan || {};
              const scanObj = Array.isArray(scan) ? (scan[0] || {}) : scan;
              const date = scanObj.scandate || scanObj.scanDate;
              const time = scanObj.scantime || scanObj.scanTime;
              if (!date && !time) return "-";
              const formattedDate = date ? formatDate(date) : "";
              const formattedTime = time ? String(time) : "";
              return `${formattedDate} ${formattedTime}`.trim();
            }
          },
          {
            key: "status",
            label: "Status",
            cell: (row: any) => {
              const status = row.samplecollectionstatus;
              const displayStatus = getDisplayValue(status);
              return displayStatus !== "-" ? (
                <Commonbadge status={displayStatus} />
              ) : "-";
            }
          }
        ];

        const hasLinkCapability = sectionVal.some((row: any) => hasViewDetailsLink(sectionKey, row));
        if (hasLinkCapability) {
          columns.push({
            key: "view_details_action",
            label: "Actions",
            cell: (row: any) => (
              hasViewDetailsLink(sectionKey, row) ? (
                <Button
                  color="link"
                  className="p-0 text-primary text-decoration-underline font-weight-medium d-inline-flex align-items-center gap-1"
                  onClick={() => handleNavigateToView(sectionKey, row , navigate)}
                  style={{ fontSize: "12px" }}
                >
                  <i className="ri-external-link-line" /> View Details
                </Button>
              ) : "-"
            )
          });
        }

        return (
          <div className="table-responsive shadow-sm rounded border bg-white p-2">
            <CommonTableIndexWise
              columns={columns}
              data={sectionVal}
              hideAction={true}
              pageSize={10}
              currentPage={1}
              totalRecords={sectionVal.length}
              paginationShow={false}
            />
          </div>
        );
      }

      const isCRFSection =
        sectionKey.toLowerCase().includes("crf") ||
        sectionVal.some((item: any) => item && typeof item === "object" && (item.crfdetails !== undefined || item.crfDetails !== undefined || item.crfid !== undefined || item.crfId !== undefined));

      if (isCRFSection) {
        const columns = [
          {
            key: "crfName",
            label: "CRF Name",
            cell: (row: any) => getDisplayValue(row.crfname || row.crfName || row["CRF Name"])
          },
          {
            key: "reportedBy",
            label: "Reported By",
            cell: (row: any) => getDisplayValue(row.reportedby || row.reportedBy || row["Reported By"])
          },
          {
            key: "reportedDate",
            label: "Reported Date",
            cell: (row: any) => {
              const dateVal = row.reporteddate || row.reportedDate || row["Reported Date"];
              return dateVal ? formatDate(dateVal) : "-";
            }
          },
          {
            key: "reportedTime",
            label: "Reported Time",
            cell: (row: any) => getDisplayValue(row.reportedtime || row.reportedTime || row["Reported Time"])
          },
          {
            key: "actions",
            label: "Actions",
            cell: (row: any) => (
              <Button
                color="primary"
                outline
                size="sm"
                className="py-1 px-3 rounded-pill fs-11 fw-bold d-inline-flex align-items-center gap-1"
                onClick={() => setSelectedCRF(row)}
              >
                <i className="ri-eye-line" /> View
              </Button>
            )
          }
        ];

        return (
          <div className="table-responsive shadow-sm rounded border bg-white p-2">
            <CommonTableIndexWise
              columns={columns}
              data={sectionVal}
              hideAction={true}
              pageSize={10}
              currentPage={1}
              totalRecords={sectionVal.length}
              paginationShow={false}
            />
          </div>
        );
      }

      // Check if it is an attachment list (only if it doesn't contain rich metadata columns like reportname, remarks, etc.)
      const isAttachmentSection =
        (sectionKey.toLowerCase().includes("attachment") || sectionKey.toLowerCase().includes("file")) &&
        !sectionVal.some((item) => 
          item && typeof item === "object" && 
          Object.keys(item).some(k => 
            ["reportname", "remarks", "reporteddate", "testname", "result", "value", "reference"].includes(k.toLowerCase())
          )
        );

      if (isAttachmentSection) {
        return (
          <div className={styles.attachmentList}>
            {sectionVal.map((file: any, idx: number) => {
              const fileName = file.name || file.filename || file["File Name"] || `Attachment-${idx + 1}`;
              const filePath = file.path || file.filepath || file.Path || "";
              const fileSize = file.size || file.filesize || file["File Size"] || "—";
              const ext = file.extension || file.fileextension || file.Extension || fileName.split(".").pop() || "";
              const typeLabel = file.attachmenttypetext || file.attachmenttype || file.Extension || "FILE";

              return (
                <div className={styles.attachmentCard} key={idx}>
                  <div className={styles.fileInfo}>
                    <div className={styles.fileIcon}>
                      <i className={getFileIcon(ext.replace(".", ""))} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className={styles.fileName}>
                        <TruncatedText text={fileName} />
                      </div>
                      <div className={styles.fileMeta}>
                        {fileSize} | Type: {String(typeLabel).toUpperCase()}
                      </div>
                    </div>
                  </div>
                  {filePath && (
                    <div className={styles.fileActions}>
                      <i
                        className="ri-eye-line cursor-pointer text-primary"
                        title="Preview"
                        onClick={() => onViewAttachment(filePath)}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      }

      // Check if array items contain nested objects (like Visits with Visit Information, Activities, etc.)
      const hasNestedObjects = sectionVal.some(
        (item: any) =>
          item &&
          typeof item === "object" &&
          Object.values(item).some((val) => val && typeof val === "object")
      );

      // Force card layout for specific modules
      const isCardLayoutModule =
        sectionKey.toLowerCase().includes("adverse") ||
        sectionKey.toLowerCase().includes("block") ||
        sectionKey.toLowerCase().includes("dropout") ||
        sectionKey.toLowerCase().includes("drop out") ||
        sectionKey.toLowerCase().includes("transfer");

      if (hasNestedObjects || isCardLayoutModule) {
        return (
          <div className="d-flex flex-column gap-3">
            {sectionVal.map((item: any, idx: number) => {
              const timepointVal = item.timepoint !== undefined && item.timepoint !== null 
                ? String(item.timepoint) 
                : (item.timepointname || item.timepointNumber || item.timepoint_number || item.timepointnumber || item.timePoint);
              
              const activityVal = item.activityname || item.activityName || item["Activity Name"] || item.activitydescription || item.activityDescription;
              const nameVal = item.name || item.title || item.label || item.code || item.reportname || item.reportName || item.filename || item.fileName;
              const eventVal = item.adverseeventnumber || item.adverseEventNumber;

              const resolvedId = findRecordId(item);
              const isBlock = sectionKey.toLowerCase().includes("block");
              const isDropout = sectionKey.toLowerCase().includes("dropout") || sectionKey.toLowerCase().includes("drop out");
              const isTransfer = sectionKey.toLowerCase().includes("transfer");

              const blockVal = resolvedId ? `ID: ${resolvedId}` : (item.blocktype || item.Blocktype || item.blockreason || item.Blockreason || "");
              const dropoutVal = resolvedId ? `ID: ${resolvedId}` : (item.dropoutreason || item.Dropoutreason || item.reason || item.Reason || "");
              const transferVal = resolvedId ? `ID: ${resolvedId}` : (item.transferreason || item.Transferreason || item.reason || item.Reason || "");

              const itemTitle =
                item["crfname"] ||
                item["crfName"] ||
                item["CRF Name"] ||
                (timepointVal !== undefined && timepointVal !== null ? `Timepoint ${timepointVal}` : null) ||
                (activityVal ? `Activity: ${activityVal}` : null) ||
                (eventVal ? `Event: ${eventVal}` : null) ||
                (isBlock && blockVal ? `Block Record` : null) ||
                (isDropout && dropoutVal ? `Dropout Record` : null) ||
                (isTransfer && transferVal ? `Transfer Record` : null) ||
                item["Visit Information"]?.["Visit Name"] ||
                item["visitinformation"]?.["visitname"] ||
                item["Visit Information"]?.["Visit Number"] ||
                item["visitinformation"]?.["visitnumber"] ||
                (item["Period Number"] ? `Period ${item["Period Number"]}` : null) ||
                (item["periodnumber"] ? `Period ${item["periodnumber"]}` : null) ||
                item["Period Number"] ||
                item["periodnumber"] ||
                (nameVal ? String(nameVal) : null) ||
                `${formatLabel(sectionKey)} Item ${idx + 1}`;

              const badgeNode = (
                <div className="d-flex align-items-center gap-2">
                  {hasViewDetailsLink(sectionKey, item) && (
                    <Button
                      color="primary"
                      outline
                      size="sm"
                      className="py-0 px-2 fs-11 font-weight-bold"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNavigateToView(sectionKey, item , navigate);
                      }}
                    >
                      <i className="ri-external-link-line me-1" /> View Details
                    </Button>
                  )}
                </div>
              );

              // Unify scalar properties and nested properties into a tab-based system inside the card
              const scalars = Object.entries(item).filter(
                ([k, val]) => k.toLowerCase() !== "id" && (val === null || val === undefined || (typeof val !== "object" && !Array.isArray(val)))
              );

              const nestedEntries = Object.entries(item).filter(([subKey, subVal]) => {
                if (subKey.toLowerCase() === "id") return false;
                if (subVal === null || subVal === undefined) return false;
                if (typeof subVal !== "object" && !Array.isArray(subVal)) return false;
                return true;
              });

              const cardTabs: { key: string; label: string; type: "scalars" | "nested"; value: any }[] = [];
              
              if (scalars.length > 0) {
                cardTabs.push({
                  key: "main_details",
                  label: formatLabel(sectionKey),
                  type: "scalars",
                  value: scalars
                });
              }

              nestedEntries.forEach(([subKey, subVal]) => {
                cardTabs.push({
                  key: subKey,
                  label: formatLabel(subKey),
                  type: "nested",
                  value: subVal
                });
              });

              // Ensure tab labels are unique and clear
              const usedLabels = new Set<string>();
              cardTabs.forEach((tab) => {
                let label = tab.label;
                if (tab.key === "main_details" && (label.toLowerCase() === "crf details" || label.toLowerCase() === "crfdetails")) {
                  label = "General Information";
                }
                if (usedLabels.has(label)) {
                  if (tab.key === "main_details") {
                    label = "General Information";
                  } else {
                    label = `${label} Details`;
                  }
                }
                if (usedLabels.has(label)) {
                  label = `${label} (${tab.key})`;
                }
                tab.label = label;
                usedLabels.add(label);
              });

              const subTabStateKey = `${sectionKey}-${idx}`;
              const activeSubTab = activeSubTabs[subTabStateKey] || (cardTabs[0]?.key || "");

              const handleSubTabChange = (key: string) => {
                setActiveSubTabs((prev:any) => ({
                  ...prev,
                  [subTabStateKey]: key
                }));
              };

              return (
                <CollapsibleCard
                  key={idx}
                  title={itemTitle}
                  badge={badgeNode}
                  defaultExpanded={false}
                >
                  <div className="d-flex flex-column gap-3">
                    {/* Chip selector bar inside the card if there are multiple tabs */}
                    {cardTabs.length > 1 && (
                      <Nav pills className="gap-2 mb-2 pb-2 border-bottom flex-nowrap overflow-auto" style={{ borderColor: "#f1f5f9" }}>
                        {cardTabs.map((tab) => {
                          const isActive = activeSubTab === tab.key;
                          
                          // Resolve icon
                          let icon = "ri-folder-line";
                          const lowerKey = tab.key.toLowerCase();
                          if (lowerKey.includes("info") || lowerKey.includes("detail") || tab.key === "main_details") {
                            icon = "ri-information-line";
                          } else if (lowerKey.includes("checkin") || lowerKey.includes("checkout") || lowerKey.includes("check in") || lowerKey.includes("check out")) {
                            icon = "ri-user-shared-line";
                          } else if (lowerKey.includes("activity") || lowerKey.includes("result")) {
                            icon = "ri-pulse-line";
                          } else if (lowerKey.includes("decision")) {
                            icon = "ri-checkbox-circle-line";
                          } else if (lowerKey.includes("barcode") || lowerKey.includes("scan")) {
                            icon = "ri-qr-code-line";
                          }

                          return (
                            <NavItem key={tab.key} style={{ whiteSpace: "nowrap" }}>
                              <NavLink
                                className={`cursor-pointer d-flex align-items-center px-2.5 py-1 rounded-pill fs-12 fw-semibold transition-all`}
                                active={isActive}
                                onClick={() => handleSubTabChange(tab.key)}
                                style={{
                                  backgroundColor: isActive ? "#4d84deff" : "transparent",
                                  color: isActive ? "#fff" : "#64748b",
                                  border: isActive ? "none" : "1px solid #e2e8f0",
                                  boxShadow: isActive ? "0 4px 6px -1px rgba(59, 130, 246, 0.2), 0 2px 4px -1px rgba(59, 130, 246, 0.06)" : "none",
                                  transition: "all 0.2s ease-in-out"
                                }}
                              >
                                <i className={`${icon} me-2 fs-14`} />
                                {tab.label}
                              </NavLink>
                            </NavItem>
                          );
                        })}
                      </Nav>
                    )}

                    {/* Content for active inner tab */}
                    {(() => {
                      const activeTabObj = cardTabs.find(t => t.key === activeSubTab);
                      if (!activeTabObj) return null;

                      if (activeTabObj.type === "scalars") {
                        const scalarsVal = activeTabObj.value;
                        return (
                          <div
                            className={styles.infoGrid}
                            style={{ backgroundColor: "#f8fafc", padding: "0.75rem", borderRadius: "6px" }}
                          >
                            {scalarsVal.map(([fieldKey, fieldVal]: [string, any]) => (
                              <div className={styles.infoItem} key={fieldKey}>
                                <label>{formatLabel(fieldKey)}</label>
                                {isStatusField(fieldKey) ? (
                                  <div>
                                    {getDisplayValue(fieldVal) !== "-" ? (
                                      <Commonbadge status={String(fieldVal)} />
                                    ) : "-"}
                                  </div>
                                ) : (fieldKey.toLowerCase().includes("date") || fieldKey.toLowerCase() === "dob") && fieldVal && typeof fieldVal === "string" && isNaN(Number(fieldVal)) && !isNaN(Date.parse(fieldVal)) ? (
                                  <span>{formatDate(fieldVal)}</span>
                                ) : (
                                  <span style={{ display: "inline-block", maxWidth: "100%" }}>
                                    {typeof fieldVal === "string" && fieldVal.length > 30 ? (
                                      <TruncatedText text={fieldVal} />
                                    ) : (
                                      getDisplayValue(fieldVal)
                                    )}
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        );
                      }

                      // Nested sub-entry
                      const subKey = activeTabObj.key;
                      const subVal = activeTabObj.value;

                      // If it's a CRF Details object
                      if (subKey.toLowerCase().includes("crf") && typeof subVal === "object" && !Array.isArray(subVal)) {
                        return (
                          <div key={subKey} style={{ gridColumn: "1 / -1" }}>
                            {cardTabs.length <= 1 && (
                              <div
                                className="fw-semibold text-secondary fs-12 mb-2 uppercase-tracking-wider"
                                style={{ letterSpacing: "0.05em" }}
                              >
                                {formatLabel(subKey).toUpperCase()}
                              </div>
                            )}
                            {renderCRFDetails(subVal)}
                          </div>
                        );
                      }

                      // If it's a flat object (like Visit Information or Check In / Check Out)
                      if (typeof subVal === "object" && !Array.isArray(subVal)) {
                        return (
                          <div key={subKey}>
                            {cardTabs.length <= 1 && (
                              <div
                                className="fw-semibold text-secondary fs-12 mb-2 uppercase-tracking-wider"
                                style={{ letterSpacing: "0.05em" }}
                              >
                                {formatLabel(subKey).toUpperCase()}
                              </div>
                            )}
                            <div
                              className={styles.infoGrid}
                              style={{ backgroundColor: "#f8fafc", padding: "0.75rem", borderRadius: "6px" }}
                            >
                              {Object.entries(subVal)
                                .filter(([fieldKey]) => fieldKey.toLowerCase() !== "id")
                                .map(([fieldKey, fieldVal]: [string, any]) => (
                                <div className={styles.infoItem} key={fieldKey}>
                                  <label>{formatLabel(fieldKey)}</label>
                                  {isStatusField(fieldKey) ? (
                                    <div>
                                      {getDisplayValue(fieldVal) !== "-" ? (
                                        <Commonbadge status={String(fieldVal)} />
                                      ) : "-"}
                                    </div>
                                  ) : (fieldKey.toLowerCase().includes("date") || fieldKey.toLowerCase() === "dob") && fieldVal && typeof fieldVal === "string" && isNaN(Number(fieldVal)) && !isNaN(Date.parse(fieldVal)) ? (
                                    <span>{formatDate(fieldVal)}</span>
                                  ) : (
                                    <span style={{ display: "inline-block", maxWidth: "100%" }}>
                                      {typeof fieldVal === "string" && fieldVal.length > 30 ? (
                                        <TruncatedText text={fieldVal} />
                                      ) : (
                                        getDisplayValue(fieldVal)
                                      )}
                                    </span>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      }

                      // If it's a sub-array (like Activities)
                      if (Array.isArray(subVal)) {
                        return (
                          <div key={subKey}>
                            {cardTabs.length <= 1 && (
                              <div
                                className="fw-semibold text-secondary fs-12 mb-2 uppercase-tracking-wider"
                                style={{ letterSpacing: "0.05em" }}
                              >
                                {formatLabel(subKey).toUpperCase()}
                              </div>
                            )}
                            {renderSectionData(subKey, subVal , navigate, setSelectedCRF, onViewAttachment, activeSubTabs, setActiveSubTabs)}
                          </div>
                        );
                      }

                      return null;
                    })()}
                  </div>
                </CollapsibleCard>
              );
            })}
          </div>
        );
      }

      // Standard Table rendering for simple arrays of objects
      const rawHeaders = Object.keys(sectionVal[0] || {}).filter(h => h.toLowerCase() !== "id");
      if (rawHeaders.length === 0) {
        return <div className="text-muted small">No data fields available.</div>;
      }

      // Check if table rows have embedded files (i.e. one of the keys represents a file path)
      const filePathKey = rawHeaders.find((h) => {
        const lowerH = h.toLowerCase().replace(/[\s_-]/g, "");
        return lowerH === "filepath" || lowerH === "path";
      });

      let headers = [...rawHeaders];
      let hasEmbeddedFile = false;
      let pathKeyName = "";
      let nameKeyName = "";
      let extKeyName = "";
      let sizeKeyName = "";

      if (filePathKey) {
        hasEmbeddedFile = true;
        pathKeyName = filePathKey;

        // Find matching name, extension, size keys to skip
        const fileNameKey = rawHeaders.find((h) => {
          const lowerH = h.toLowerCase().replace(/[\s_-]/g, "");
          return lowerH === "filename" || lowerH === "name";
        });
        if (fileNameKey) nameKeyName = fileNameKey;

        const extKey = rawHeaders.find((h) => {
          const lowerH = h.toLowerCase().replace(/[\s_-]/g, "");
          return lowerH === "extension" || lowerH === "ext" || lowerH === "fileextension";
        });
        if (extKey) extKeyName = extKey;

        const sizeKey = rawHeaders.find((h) => {
          const lowerH = h.toLowerCase().replace(/[\s_-]/g, "");
          return lowerH === "size" || lowerH === "filesize";
        });
        if (sizeKey) sizeKeyName = sizeKey;

        // Skip type columns
        const typeKey = rawHeaders.find((h) => {
          const lowerH = h.toLowerCase().replace(/[\s_-]/g, "");
          return lowerH === "type" || lowerH === "filetype";
        });

        // Filter these keys out of the headers list
        headers = rawHeaders.filter((h) => {
          if (h === pathKeyName) return false;
          if (fileNameKey && h === fileNameKey) return false;
          if (extKey && h === extKey) return false;
          if (sizeKey && h === sizeKey) return false;
          if (typeKey && h === typeKey) return false;
          return true;
        });
      }

      const columns = headers.map((h) => ({
        key: h,
        label: formatLabel(h),
        cell: (row: any) => {
          const val = row[h];
          if (val === null || val === undefined) return "—";
          if (typeof val === "boolean") return val ? "Yes" : "No";

          if (h.toLowerCase().includes("status") || h.toLowerCase().includes("result") || h.toLowerCase().includes("decision")) {
            return <Commonbadge status={String(val)} />;
          }
          if (h.toLowerCase().includes("date") && !isNaN(Date.parse(String(val)))) {
            return formatDate(val);
          }

          // If the field is attachments list inside a table row
          if (Array.isArray(val)) {
            const isAttachmentList = val.some((item: any) => item && (item.path || item.filepath || item.Path || item.attachmentid));
            if (isAttachmentList) {
              return (
                <div className="d-flex flex-column gap-1">
                  {val.map((att: any, aIdx: number) => {
                    const name = att.name || att.filename || att["File Name"] || `File-${aIdx + 1}`;
                    return (
                      <span
                        key={aIdx}
                        className="text-primary cursor-pointer text-decoration-underline"
                        onClick={() => onViewAttachment(att.path || att.filepath || att.Path)}
                        style={{ fontSize: "11px" }}
                      >
                        <i className="ri-attachment-line me-1" />
                        {name}
                      </span>
                    );
                  })}
                </div>
              );
            }
            const joinedText = val.map((item: any) => typeof item === "object" ? JSON.stringify(item) : String(item)).join(", ");
            return (
              <span style={{ display: "inline-block", maxWidth: "250px" }}>
                {joinedText.length > 25 ? (
                  <TruncatedText text={joinedText} />
                ) : (
                  joinedText
                )}
              </span>
            );
          }
          return (
            <span style={{ display: "inline-block", maxWidth: "250px" }}>
              {typeof val === "string" && val.length > 25 ? (
                <TruncatedText text={val} />
              ) : (
                String(val)
              )}
            </span>
          );
        },
      }));

      // Add a custom Attachment column at the end if the table had embedded files
      if (hasEmbeddedFile && pathKeyName) {
        columns.push({
          key: "embedded_attachment",
          label: "Attachment",
          cell: (row: any) => {
            const pathVal = row[pathKeyName];
            if (!pathVal) return "—";

            const nameVal = nameKeyName ? row[nameKeyName] : "File";
            const extVal = extKeyName ? row[extKeyName] : "";
            const sizeVal = sizeKeyName ? row[sizeKeyName] : "";

            const displayName = String(nameVal).includes(".") || !extVal ? String(nameVal) : `${nameVal}.${extVal}`;
            const sizeLabel = sizeVal ? ` (${sizeVal})` : "";

            return (
              <span
                className="text-primary cursor-pointer text-decoration-underline d-inline-flex align-items-center gap-1"
                onClick={() => onViewAttachment(pathVal)}
                style={{ fontSize: "12px", fontWeight: 500 }}
              >
                <i className="ri-attachment-line" />
                {displayName}
                {sizeLabel && <span className="text-muted" style={{ fontSize: "10px" }}>{sizeLabel}</span>}
              </span>
            );
          }
        });
      }

      // Add a custom Action column at the end if the table has view details capability
      const hasLinkCapability = sectionVal.some((row: any) => hasViewDetailsLink(sectionKey, row));
      if (hasLinkCapability) {
        columns.push({
          key: "view_details_action",
          label: "Actions",
          cell: (row: any) => (
            hasViewDetailsLink(sectionKey, row) ? (
              <Button
                color="link"
                className="p-0 text-primary text-decoration-underline font-weight-medium d-inline-flex align-items-center gap-1"
                onClick={() => handleNavigateToView(sectionKey, row, navigate)}
                style={{ fontSize: "12px" }}
              >
                <i className="ri-external-link-line" /> View Details
              </Button>
            ) : "—"
          )
        });
      }

      return (
        <CommonTableIndexWise
          columns={columns}
          data={sectionVal}
          hideAction={true}
          pageSize={10}
          currentPage={1}
          totalRecords={sectionVal.length}
          paginationShow={false}
        />
      );
    }

    // Case 2: Flat Object (key-value pairs)
    if (typeof sectionVal === "object") {
      const entries = Object.entries(sectionVal);

      // Find if there is an embedded file path key
      const filePathEntry = entries.find(([k]) => {
        const lowerK = k.toLowerCase().replace(/[\s_-]/g, "");
        return lowerK === "filepath" || lowerK === "path";
      });

      let fileCardNode: React.ReactNode = null;
      let keysToSkip = new Set<string>();

      if (filePathEntry) {
        const [pathKey, filePathVal] = filePathEntry;
        if (filePathVal && typeof filePathVal === "string") {
          // Find matching name and extension
          const fileNameEntry = entries.find(([k]) => {
            const lowerK = k.toLowerCase().replace(/[\s_-]/g, "");
            return lowerK === "filename" || lowerK === "name";
          });
          const extEntry = entries.find(([k]) => {
            const lowerK = k.toLowerCase().replace(/[\s_-]/g, "");
            return lowerK === "extension" || lowerK === "ext" || lowerK === "fileextension";
          });
          const typeEntry = entries.find(([k]) => {
            const lowerK = k.toLowerCase().replace(/[\s_-]/g, "");
            return lowerK === "type" || lowerK === "filetype";
          });

          const fileName = (fileNameEntry ? String(fileNameEntry[1]) : "") || "Document File";
          const fileExt = (extEntry ? String(extEntry[1]) : "") || fileName.split(".").pop() || "pdf";
          const fileType = typeEntry ? String(typeEntry[1]) : "";

          // Mark these keys to be skipped in the regular list
          keysToSkip.add(pathKey);
          if (fileNameEntry) keysToSkip.add(fileNameEntry[0]);
          if (extEntry) keysToSkip.add(extEntry[0]);
          if (typeEntry) keysToSkip.add(typeEntry[0]);

          fileCardNode = (
            <div style={{ gridColumn: "1 / -1", marginTop: "0.5rem" }} key="embedded-file-card">
              <label className="d-block mb-1">{formatLabel("Attachment")}</label>
              <div className={styles.attachmentCard} style={{ maxWidth: "450px" }}>
                <div className={styles.fileInfo}>
                  <div className={styles.fileIcon}>
                    <i className={getFileIcon(fileExt.replace(".", ""))} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className={styles.fileName}>
                      <TruncatedText text={fileName.includes(".") ? fileName : `${fileName}.${fileExt}`} />
                    </div>
                    <div className={styles.fileMeta}>
                      {fileType || "Document"}
                    </div>
                  </div>
                </div>
                <div className={styles.fileActions}>
                  <i
                    className="ri-eye-line cursor-pointer text-primary"
                    title="Preview"
                    onClick={() => onViewAttachment(filePathVal)}
                  />
                </div>
              </div>
            </div>
          );
        }
      }

      const hasLink = hasViewDetailsLink(sectionKey, sectionVal);

      // Check if this flat object is Volunteer Information
      const isVolunteerInfo =
        sectionKey.toLowerCase().includes("volunteerinformation") ||
        sectionKey.toLowerCase().includes("volunteer information") ||
        entries.some(([k]) => k.toLowerCase() === "volunteercode" || k.toLowerCase() === "fullname");

      if (isVolunteerInfo) {
        // Extract profileimage, signature, fullname, volunteercode, currentstatus to show in header
        const profileImageEntry = entries.find(([k]) => k.toLowerCase() === "profileimage" || k.toLowerCase() === "profilephoto" || k.toLowerCase() === "profileimg");
        const signatureEntry = entries.find(([k]) => k.toLowerCase() === "signature");
        const fullNameEntry = entries.find(([k]) => k.toLowerCase() === "fullname");
        const volunteerCodeEntry = entries.find(([k]) => k.toLowerCase() === "volunteercode");
        const currentStatusEntry = entries.find(([k]) => k.toLowerCase() === "currentstatus");

        const profileImgRaw = profileImageEntry ? String(profileImageEntry[1] || "") : "";
        const profileImgVal = (profileImgRaw && profileImgRaw !== "null" && profileImgRaw.trim() !== "") ? profileImgRaw : "";
        const signatureVal = signatureEntry ? String(signatureEntry[1] || "") : "";
        const fullNameVal = fullNameEntry ? String(fullNameEntry[1] || "") : "—";
        const volunteerCodeVal = volunteerCodeEntry ? String(volunteerCodeEntry[1] || "") : "—";
        const statusVal = currentStatusEntry ? String(currentStatusEntry[1] || "") : "";

        // Collect keys to skip in the grid
        const keysToSkipHeader = new Set<string>([
          "profileimage", "profilephoto", "profileimg",
          "signature", "fullname", "volunteercode", "currentstatus"
        ]);

        const otherEntries = entries.filter(([k]) => !keysToSkipHeader.has(k.toLowerCase()));

        return (
          <div className="d-flex flex-column gap-3">
            {/* Elegant Profile Header Block */}
            <div
              className="py-2 px-3 mb-2 rounded d-flex flex-wrap align-items-center justify-content-between gap-3 shadow-none border"
              style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                borderColor: "#e2e8f0"
              }}
            >
              {/* Left Side: Avatar and Name/Code/Status */}
              <div className="d-flex align-items-center gap-3">
                <div style={{ position: "relative" }}>
                  <img
                    src={resolveFileUrl(profileImgVal) || profileImage}
                    alt="Volunteer Profile"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = profileImage;
                    }}
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "3px solid #fff",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
                      cursor: profileImgVal ? "pointer" : "default"
                    }}
                    onClick={() => profileImgVal && onViewAttachment(profileImgVal)}
                    title={profileImgVal ? "Click to Preview" : ""}
                  />
                  {statusVal && (
                    <div style={{ position: "absolute", bottom: "-5px", right: "-5px" }}>
                      <Commonbadge status={statusVal} style={{ fontSize: "10px", padding: "0.2rem 0.4rem" }} />
                    </div>
                  )}
                </div>

                <div className="d-flex flex-column gap-1">
                  <h5 className="mb-0 text-dark fw-bold" style={{ fontSize: "1.1rem", letterSpacing: "-0.2px" }}>
                    {fullNameVal}
                  </h5>
                  <div className="text-secondary small fw-semibold">
                    Volunteer Code: <span className="text-primary">{volunteerCodeVal}</span>
                  </div>
                </div>
              </div>

              {/* Right Side: Signature Block */}
              <div
                className="d-flex flex-column gap-1 p-2 rounded bg-white text-center border"
                style={{ minWidth: "160px", borderStyle: "dashed", borderColor: "#cbd5e1" }}
              >
                <span className="text-secondary fw-semibold" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>SIGNATURE</span>
                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "50px" }}>
                  {signatureVal ? (
                    <img
                      src={resolveFileUrl(signatureVal)}
                      alt="Signature"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.style.display = "none";
                      }}
                      style={{
                        maxHeight: "45px",
                        maxWidth: "150px",
                        objectFit: "contain",
                        cursor: "pointer"
                      }}
                      onClick={() => onViewAttachment(signatureVal)}
                      title="Click to Preview"
                    />
                  ) : (
                    <span className="text-muted" style={{ fontSize: "11px", fontStyle: "italic" }}>No Signature Provided</span>
                  )}
                </div>
              </div>
            </div>

            {/* Grid of remaining information */}
            <div className={styles.infoGrid}>
              {otherEntries.map(([fieldKey, fieldVal]: [string, any]) => {
                if (keysToSkip.has(fieldKey)) return null;
                if (fieldKey.toLowerCase() === "id") return null;
                // Treat null/empty as standard '-' values instead of skipping

                if (fieldKey.toLowerCase().includes("crf") && typeof fieldVal === "object" && fieldVal !== null && !Array.isArray(fieldVal)) {
                  return (
                    <div key={fieldKey} style={{ gridColumn: "1 / -1" }}>
                      <label className="mb-2 d-block">{formatLabel(fieldKey)}</label>
                      {renderCRFDetails(fieldVal)}
                    </div>
                  );
                }
                if (Array.isArray(fieldVal)) {
                  return (
                    <div key={fieldKey} style={{ gridColumn: "1 / -1" }}>
                      <label className="mb-2 d-block">{formatLabel(fieldKey)}</label>
                      {renderSectionData(fieldKey, fieldVal , navigate, setSelectedCRF, onViewAttachment, activeSubTabs, setActiveSubTabs)}
                    </div>
                  );
                }

                return (
                  <div className={styles.infoItem} key={fieldKey}>
                    <label>{formatLabel(fieldKey)}</label>
                    {isStatusField(fieldKey) ? (
                      <div>
                        {getDisplayValue(fieldVal) !== "-" ? (
                          <Commonbadge status={String(fieldVal)} />
                        ) : "-"}
                      </div>
                    ) : (fieldKey.toLowerCase().includes("date") || fieldKey.toLowerCase() === "dob") && fieldVal && typeof fieldVal === "string" && isNaN(Number(fieldVal)) && !isNaN(Date.parse(fieldVal)) ? (
                      <span>{formatDate(fieldVal)}</span>
                    ) : (
                      <span style={{ display: "inline-block", maxWidth: "100%" }}>
                        {typeof fieldVal === "string" && fieldVal.length > 30 ? (
                          <TruncatedText text={fieldVal} />
                        ) : (
                          getDisplayValue(fieldVal)
                        )}
                      </span>
                    )}
                  </div>
                );
              })}
              {fileCardNode}
            </div>
          </div>
        );
      }

      // Separate regular scalar fields and nested fields
      const scalarEntries: [string, any][] = [];
      const nestedEntries: [string, any][] = [];

      entries.forEach(([k, v]) => {
        if (keysToSkip.has(k)) return;
        if (k.toLowerCase() === "id") return;
        if (v === null || v === undefined) {
          scalarEntries.push([k, null]);
          return;
        }
        if (typeof v === "object" || Array.isArray(v)) {
          nestedEntries.push([k, v]);
        } else {
          scalarEntries.push([k, v]);
        }
      });

      return (
        <div className="d-flex flex-column gap-3">
          {hasLink && (
            <div className="d-flex justify-content-end">
              <Button
                color="primary"
                outline
                size="md"
                onClick={() => handleNavigateToView(sectionKey, sectionVal, navigate)}
              >
                <i className="ri-external-link-line" /> View Details
              </Button>
            </div>
          )}

          {/* Scalar fields grid */}
          {scalarEntries.length > 0 && (
            <div className={styles.infoGrid}>
              {scalarEntries.map(([fieldKey, fieldVal]) => (
                <div className={styles.infoItem} key={fieldKey}>
                  <label>{formatLabel(fieldKey)}</label>
                  {isStatusField(fieldKey) ? (
                    <div>
                      {getDisplayValue(fieldVal) !== "-" ? (
                        <Commonbadge status={String(fieldVal)} />
                      ) : "-"}
                    </div>
                  ) : (fieldKey.toLowerCase().includes("date") || fieldKey.toLowerCase() === "dob") && fieldVal && typeof fieldVal === "string" && isNaN(Number(fieldVal)) && !isNaN(Date.parse(fieldVal)) ? (
                    <span>{formatDate(fieldVal)}</span>
                  ) : (
                    <span style={{ display: "inline-block", maxWidth: "100%" }}>
                      {typeof fieldVal === "string" && fieldVal.length > 30 ? (
                        <TruncatedText text={fieldVal} />
                      ) : (
                        getDisplayValue(fieldVal)
                      )}
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Attachment file card */}
          {fileCardNode}

          {/* Nested entries (like checklists, tables) */}
          {nestedEntries.length > 0 && (
            <div className="d-flex flex-column gap-3 pt-2">
              {nestedEntries.map(([fieldKey, fieldVal]) => (
                <div key={fieldKey} style={{ width: "100%" }}>
                  <div
                    className="fw-semibold text-secondary fs-12 mb-2 uppercase-tracking-wider"
                    style={{ letterSpacing: "0.05em" }}
                  >
                    {formatLabel(fieldKey).toUpperCase()}
                  </div>
                  {renderSectionData(fieldKey, fieldVal, navigate, setSelectedCRF, onViewAttachment, activeSubTabs, setActiveSubTabs)}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }

    return <span>{String(sectionVal)}</span>;
  };



export  const tabConfigMap: Record<string, { label: string, icon: string, classType: string }> = {
    registration: { label: "Registration", icon: "ri-user-line", classType: "green" },
    preblock: { label: "Pre Block", icon: "ri-ban-line", classType: "red" },
    assigned: { label: "Assigned", icon: "ri-file-text-line", classType: "green" },
    screening: { label: "Screening", icon: "ri-pulse-line", classType: "green" },
    transfer: { label: "Study Transfer", icon: "ri-exchange-line", classType: "orange" },
    enrollment: { label: "Enrollment", icon: "ri-shield-user-line", classType: "green" },
    periods: { label: "Periods", icon: "ri-calendar-2-line", classType: "blue" },
    ambulatoryVisit: { label: "Ambulatory Visit", icon: "ri-walk-line", classType: "grey" },
    adverseEvent: { label: "Adverse Event", icon: "ri-error-warning-line", classType: "grey" },
    dropOut: { label: "Drop Out", icon: "ri-logout-box-r-line", classType: "grey" },
    postblock: { label: "Post Block", icon: "ri-lock-line", classType: "grey" },
    completion: { label: "Study Completed", icon: "ri-award-line", classType: "grey" },
  };

export const normalizeDashboardTabs = (
  rawTabs: Record<string, any> | null | undefined
): Record<string, any> | null => {
  if (!rawTabs) return null;

  const finalTabs: Record<string, any> = {};

  Object.entries(rawTabs).forEach(([key, val]) => {
    if (val && typeof val === "object") {
      const rawTab = (val as any).tab || (val as any).tabInfo;

      let tabInfo = null;

      if (rawTab && typeof rawTab === "object") {
        tabInfo = {
          title: rawTab.title || rawTab.Title || "",
          status: rawTab.status || rawTab.Status || "",
          completed:
            rawTab.completed !== undefined
              ? rawTab.completed
              : rawTab.Completed,
          performedBy:
            rawTab.performedby ||
            rawTab.performedBy ||
            rawTab.PerformedBy ||
            null,
          performedDate:
            rawTab.performeddate ||
            rawTab.performedDate ||
            rawTab.PerformedDate ||
            null,
          visible:
            rawTab.visible !== undefined
              ? rawTab.visible
              : rawTab.Visible !== undefined
              ? rawTab.Visible
              : true,
          enabled:
            rawTab.enabled !== undefined
              ? rawTab.enabled
              : rawTab.Enabled !== undefined
              ? rawTab.Enabled
              : true,
        };
      }

      const normalizedValue = {
        ...(val as Record<string, any>),
        tabInfo,
      };

      switch (key.toLowerCase()) {
        case "ambulatoryvisit":
          finalTabs.ambulatoryVisit = normalizedValue;
          break;

        case "adverseevent":
          finalTabs.adverseEvent = normalizedValue;
          break;

        case "dropout":
          finalTabs.dropOut = normalizedValue;
          break;

        case "studycompletion":
        case "completion":
          finalTabs.completion = normalizedValue;
          break;

        default:
          finalTabs[key] = normalizedValue;
      }
    } else {
      finalTabs[key] = val;
    }
  });

  return finalTabs;
};
export const extractVolunteerInfo = (obj: any) => {
  let volunteerCode = "";
  let subjectNo = "";

  const searchKeys = (data: any) => {
    if (!data || typeof data !== "object") return;

    if (Array.isArray(data)) {
      data.forEach(searchKeys);
      return;
    }

    for (const [k, v] of Object.entries(data)) {
      if (v == null) continue;

      const lowerK = k.toLowerCase().replace(/[^a-z0-9]/g, "");

      if (typeof v !== "object" && !Array.isArray(v)) {
        if (lowerK === "volunteercode" || lowerK === "volunteeridcode") {
          volunteerCode = String(v);
        } else if (lowerK === "subjectnumber" || lowerK === "subjectno") {
          subjectNo = String(v);
        } else if (lowerK === "subjectbarcode" && !subjectNo) {
          subjectNo = String(v);
        }
      } else {
        searchKeys(v);
      }
    }
  };

  searchKeys(obj);

  return {
    volunteerCode,
    subjectNo,
  };
};